import { vservice } from '@niknevis/vue-modules'
import Dialog from 'quasar/src/plugins/Dialog.js';
import DeleteConfirm from '@/modules/common/dialog/components/shared/DeleteConfirm.vue'
import { AdminLatestNewsRoutes } from '@/modules/news/routes/admin-news.route'
import { Inertia } from '@/modules/shared/helpers/http/facades/inertia'

@vservice()
export class AdminLatestNewsServices {

  constructor(private readonly adminLatestNewsRoutes: AdminLatestNewsRoutes) {
  }

  create(data: {}) {
    return Inertia.post(
      this.adminLatestNewsRoutes.store(),
      data
    )
  }

  edit(newsId: number, data: {}) {
    return Inertia.put(
      this.adminLatestNewsRoutes.update(newsId),
      data
    )
  }

  destroy(id: number) {
    return Inertia.delete(
      this.adminLatestNewsRoutes.destroy(id)
    ).onBeforeAsync(() => new Promise<boolean>((resolve) => {
      Dialog.create({
        component: DeleteConfirm,
        title: 'حذف خبر',
        message: 'آیا از حذف خبر اطمینان دارید ؟'
      }).onOk(() => resolve(true))
        .onCancel(() => resolve(false))
        .onDismiss(() => resolve(false))
    }))
  }
}

